<template>
  <div class="hello">
    <div class="bg">

        <div class="footer" style="background:rgba(247,247,247,1)">
           <div class="content" >
              <div class="navT">
                  <span >{{title}}</span>
              </div>
              <div class="contentList_img" v-if="content == ''">
                <img v-if="lang == 'cn'" src="../assets/image/wu.png" alt="">
                <img v-else src="../assets/image/wuE.png" alt="">
              </div>
              <div class="contentList" v-else ref="conten" @scroll="getSc" v-html="content">
              </div>
			  <div style="height: 100px;"></div>
                <fiex :shows="fixed" :fatherMethod="goTop" ></fiex>
           </div>
        </div>
    </div>
  </div>
</template>

<script>
    import fiex from '../components/fiex.vue'
  export default{
    components:{
      fiex
    },
    data(){
      return {
        fixed:false,
          imageUrl:require('../assets/image/banner1.png'),
          image:require('../assets/image/news.png'),
          content:'',
          title:'',
          lang:'cn'
      }
    },
    created() {
      if(localStorage.getItem('languageSet') == 'zh'){
        this.lang = 'en'
      }else{
        this.lang = 'cn'
      }
      var data = {
        id:this.$route.query.id
      }
      this.$fetch('/news/detail',data).then(res=>{
          console.log(res)
          this.content = res.data.content;
          this.title = res.data.title;
      })
    },
    methods:{
      goTop(){
        this.$refs.conten.scrollTop = 0;
      },
      getSc(){
          var scrollTop = document.documentElement.scrollTop || document.body.scrollTop || this.$refs.conten.scrollTop ||
            window.pageYOffset;

            if(scrollTop > 20){
              this.fixed = true;
            }else{
              this.fixed = false;
            }
      }
    }
  }
</script>

<style scoped="scoped">
  @import url("../assets/css/newsDetails.css");
</style>



// WEBPACK FOOTER //
// src/pages/newsDetail.vue